<template>
    <v-layout row>
        <v-flex xs11>
            <v-textarea v-if="editing" ref="textarea"
                v-model="comment.content"
                auto-grow
                autofocus
                rows="1"
                class="body-1"
                @blur="blur"
                @input="input"
                @keyup.13.prevent="enter"
                @keyup.esc="escape"
                @keyup.z="keyz"
                :loading="loading"
            ></v-textarea>
            <div v-else>
                <vue-markdown class="mt-3 body-1 comment-content" :source="comment.content"></vue-markdown>  
                <!--
                <div class="caption text-xs-right grey--text">
                    {{comment.userByUserId.fullName}}
                    {{$d(new Date(comment.timestamp), 'long')}}
                </div>
                -->
            </div>
        </v-flex>
        <v-flex xs1>
            <v-btn
                fab small flat
                color="blue-grey"
                @click="click"
            >
                <v-icon dark>edit</v-icon>
            </v-btn>
        </v-flex>
    </v-layout>
</template>

<style>
    textarea.v-textarea {
        margin-top: 5px
    }
    .comment-content ul {
        margin-bottom: 16px;
    }
    div.comment-content {
        overflow-wrap: break-word;
    }
</style>

<script>
import {
  addCommentMutation,
  updateCommentByIdMutation,
  deleteCommentByIdMutation
} from "@/graphql/commentQueries.gql";
import VueMarkdown from 'vue-markdown'

export default {
    components: { VueMarkdown },
    props: [ 'comment', 'edit' ],
    data() { return {
        editing: this.edit,
        loading: false,
        originalContent: this.comment.content,
        undoContent: this.comment.content,
    }},
    methods: {
        click() {
            if (!this.editing && !this.lastBlur || new Date().getTime() - this.lastBlur > 500) {
                this.undoContent = this.comment.content
                this.editing = true
            }
        },
        blur() {
            if (this.inputTimeout) clearTimeout(this.inputTimeout)
            this.lastBlur = new Date().getTime()
            if (this.editing) {
                if (this.comment.content && this.comment.content.trim().length > 0) {
                    if (this.originalContent != this.comment.content) {
                        this.mutateComment().then(() => { 
                            this.editing = false 
                            this.$emit('commentEvent')
                        })
                    } else {
                        this.editing = false
                    }
                } else if (this.comment.id) {
                    this.deleteComment().then(() => { 
                        this.editing = false 
                        this.$emit('commentEvent')
                    })
                } else {
                    this.editing = false
                    this.$emit('commentEvent')
                }
            }
        },
        input() {
            if (this.inputTimeout) clearTimeout(this.inputTimeout)
            this.inputTimeout = setTimeout(() => {
                if (this.originalContent != this.comment.content) {
                    this.mutateComment()
                }
            }, 3000)
        },
        enter(event) {
            if (event.ctrlKey) {
                event.preventDefault()
                this.blur()
            }
        },
        escape() {
            this.comment.content = this.undoContent
            this.blur()
        },
        keyz(event) {
            if (event.ctrlKey) this.comment.content = this.undoContent
        },
        mutateComment() {
            var promise = null
            if (this.comment.id) {
                console.log("updating comment")
                this.loading = true
                promise = this.$apollo.mutate({
                    mutation: updateCommentByIdMutation,
                    variables: {
                        CommentData: {
                            id: this.comment.id,
                            commentPatch: {
                                content: this.comment.content
                            }
                        }
                    }
                })
            } else {
                console.log("adding comment")
                this.comment.id = this.guid()
                this.loading = true
                promise = this.$apollo.mutate({
                    mutation: addCommentMutation,
                    variables: {
                        CommentData: {
                            comment: this.comment
                        }
                    }
                })
            }
            return promise.then(data => {
                    this.loading = false
                    console.log(data)
                    this.originalContent = this.comment.content
                })
        },
        deleteComment(){
            console.log("deleting comment")
            this.loading = true
            return this.$apollo.mutate({
                mutation: deleteCommentByIdMutation,
                variables: {
                    CommentId:{
                        id: this.comment.id
                    }
                }
            }).then(data => {
                this.loading = false
                console.log(data);
                this.$emit('commentEvent')
            });
        },
        guid() {
            return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
                var r = (Math.random() * 16) | 0,
                v = c == "x" ? r : (r & 0x3) | 0x8;
                return v.toString(16);
            });
        }
    }
}
</script>